import { useEffect } from 'react';
/**
 * Adds <meta name="robots" content="noindex, nofollow"> while the page is mounted.
 * The server additionally sends an X-Robots-Tag header for crawlers that don't run JavaScript.
 */
export const useNoIndex = () => {
    useEffect(() => {
        const meta = document.createElement('meta');
        meta.name = 'robots';
        meta.content = 'noindex, nofollow';
        document.head.appendChild(meta);
        return () => {
            meta.remove();
        };
    }, []);
};
